import { humanizeKey } from "./utils-fields";
import { displayKeyFor } from "./entityTableConfig";

const HIDDEN_KEYS = new Set([
    "id",
    "pk",
    "password",
    "sifre",
    "log",
    "uuid",
    "created_by",
    "updated_by",
]);

const SKIP_IN_TABLE = [
    /^sifre$/i,
    /_bilgisi$/i,
    /_password$/i,
];

function shouldHideKey(key, explicitColumns = null) {
    if (
        key === "id" &&
        Array.isArray(explicitColumns) &&
        explicitColumns.includes("id")
    ) {
        return false;
    }
    if (HIDDEN_KEYS.has(key)) return true;
    if (/_id$/i.test(key) && key !== "dosya_no") return true;
    return SKIP_IN_TABLE.some((re) => re.test(key));
}

/** Varsayılan sütun genişlikleri — tabloyu sıkı tutar, uzun metin truncate + title ile kalır. */
const DEFAULT_COLUMN_CLASS = {
    ad: "max-w-[5.5rem]",
    soyad: "max-w-[6.5rem]",
    tc_kimlik_no: "max-w-[6.75rem]",
    tc_no: "max-w-[6.75rem]",
    telefon: "max-w-[8.5rem]",
    email: "max-w-[10.5rem]",
    aracilar: "max-w-[8rem]",
    araciya_odenen_miktar: "max-w-[5.5rem]",
    anlasma_orani: "max-w-[4.5rem]",
    vekalet_durumu: "max-w-[5.5rem]",
    olusturma_tarihi: "max-w-[5.5rem]",
    kayit_tarihi: "max-w-[5.5rem]",
    dosya_no: "max-w-[7rem]",
    plaka: "max-w-[5.5rem]",
    muvekkil: "max-w-[9.5rem]",
    muvekkil_ad_soyad: "max-w-[9.5rem]",
    sigorta_sirketi: "max-w-[9rem]",
    basvuru_turu: "max-w-[5.5rem]",
    dosya_durumu: "max-w-[6rem]",
    basvuru_konusu: "max-w-[7rem]",
    referans_kodu: "max-w-[6rem]",
    avukat: "max-w-[8rem]",
    sure_durumu: "max-w-[6rem]",
};

function inferColumnClass(key, columnWidths = {}) {
    if (columnWidths[key]) return columnWidths[key];
    if (DEFAULT_COLUMN_CLASS[key]) return DEFAULT_COLUMN_CLASS[key];
    if (/email/i.test(key)) return "max-w-[10.5rem]";
    if (/telefon|phone|gsm/i.test(key)) return "max-w-[8.5rem]";
    if (/tc_|kimlik/i.test(key)) return "max-w-[6.75rem]";
    if (/tarih|date|_at$/i.test(key)) return "max-w-[5.5rem]";
    if (/miktar|tutar|deger|fiyat|oran/i.test(key)) return "max-w-[5.5rem]";
    return "max-w-[9rem]";
}

/**
 * @returns {{ key, label, type?, cfg?, displayKey? }[]}
 */
export function buildTableColumns({
    rows = [],
    fields = [],
    listColumns = null,
    listColumnLabels = {},
    columnWidths = {},
    displayKeys = {},
}) {
    const fieldMap = new Map((fields || []).map((f) => [f.name, f]));
    const apiKeys = new Set();
    rows.forEach((r) => Object.keys(r || {}).forEach((k) => apiKeys.add(k)));

    const dispMap = {};
    for (const key of apiKeys) {
        const dk = displayKeyFor(key, apiKeys);
        if (dk) dispMap[key] = dk;
    }

    const toCol = (key) => {
        const cfg = fieldMap.get(key);
        return {
            key,
            label: listColumnLabels[key] || cfg?.label || humanizeKey(key),
            type: cfg?.type,
            cfg,
            displayKey: displayKeys[key] || dispMap[key] || null,
            cellClass: inferColumnClass(key, columnWidths),
        };
    };

    if (Array.isArray(listColumns) && listColumns.length > 0) {
        return listColumns
            .filter((k) => k && !shouldHideKey(k, listColumns))
            .map(toCol);
    }

    const order = [];
    for (const fld of fields) {
        if (fld.hidden) continue;
        if (apiKeys.has(fld.name) && !shouldHideKey(fld.name)) {
            order.push(fld.name);
        }
    }
    for (const key of apiKeys) {
        if (shouldHideKey(key)) continue;
        if (key.endsWith("_display") || key.endsWith("_label")) continue;
        if (!order.includes(key)) order.push(key);
    }

    return order.slice(0, 14).map(toCol);
}
